import { render, staticRenderFns } from "./ButtonTheme.vue?vue&type=template&id=317c1870&scoped=true&"
import script from "./ButtonTheme.vue?vue&type=script&lang=js&"
export * from "./ButtonTheme.vue?vue&type=script&lang=js&"
import style0 from "./ButtonTheme.vue?vue&type=style&index=0&id=317c1870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c1870",
  null
  
)

export default component.exports